{
  "fr": {
    "surveys": {
      "buttons": {
        "addAnswer": "Ajouter une option",
        "edit": "Cliquer pour éditer",
        "moveQuestionDown": "Déplacer la question vers le bas",
        "moveQuestionUp": "Déplacer la question vers le haut",
        "removeOption": "Supprimer l'option",
        "removeQuestion": "Supprimer la question"
      },
      "confirm": {
        "deleteQuestionText": "Cette action est irréversible. La question sera définitivement supprimée du sondage avec toutes ses options de réponse.",
        "deleteQuestionTitle": "Supprimer la question ?",
        "requiredIncompleteText": "Vous n'avez pas encore rempli tous les champs obligatoires (marqués d'un *). Veuillez les compléter pour envoyer le sondage.",
        "requiredIncompleteTitle": "Champs obligatoires manquants",
        "submitIncompleteText": "Vous n'avez pas encore répondu à toutes les questions. Votre réponse sera tout de même envoyée.",
        "submitIncompleteTitle": "Envoyer la réponse ?"
      },
      "flash": {
        "questionAdded": "Question ajoutée",
        "questionDeleted": "Question supprimée",
        "questionMoved": "Question déplacée",
        "questionUpdated": "Question mise à jour",
        "submitFailed": "Votre réponse n'a pas pu être envoyée. Veuillez réessayer."
      },
      "headers": {
        "answers": "Résultats",
        "general": "Titre et description",
        "lastAnswered": "Dernière réponse",
        "questions": "Questions",
        "responsesPerQuestion": {
          "answers": "{count} réponse | {count} réponses",
          "oClock": "heure",
          "of": "à",
          "responses": "{count} soumission | {count} soumissions"
        },
        "shareResultsLink": "Partagez ce lien vers les résultats du sondage"
      },
      "hints": {
        "average": "Moyenne",
        "evaluations": "{count} évaluation | {count} évaluations",
        "file": "Formulez une tâche pour laquelle vos élèves doivent télécharger un fichier (par exemple, un fichier texte, une image ou un PDF).",
        "long_answer": "Rédigez une tâche pour laquelle vos élèves peuvent soumettre une réponse dans un champ de texte numérique.",
        "maxOptionsReached": "Un maximum de {max} options peuvent être ajoutées.",
        "multiple_choice": "Posez une question et entrez les options de réponse. Plus d'une réponse peut être sélectionnée.",
        "noDescriptionOrOptions": "Aucune description ou option enregistrée",
        "notAnswered": "aucune indication",
        "rating": "Faites évaluer quelque chose par vos élèves avec 1 à 5 étoiles.",
        "required": "La question doit être répondue",
        "single_choice": "Posez une question et entrez les options de réponse. Une seule réponse peut être sélectionnée.",
        "submitSuccessful": "Merci d'avoir participé à ce sondage."
      },
      "inserter": {
        "title": "Ajouter un nouveau bloc"
      },
      "labels": {
        "backToResponseIndex": "Retour à l'aperçu",
        "loadingResponses": "Chargement des réponses...",
        "required": "Champ obligatoire",
        "showAllAnswers": "Afficher les détails"
      },
      "placeholders": {
        "description": "Ajouter une description",
        "optionInput": "Entrez l'option ici...",
        "question": "Question",
        "title": "Entrez le titre ici..."
      },
      "questionTypes": {
        "file": "Demander un fichier",
        "long_answer": "Réponse texte",
        "multiple_choice": "Choix multiple",
        "net_promoter_score": "Net Promoter Score (0-10)",
        "rating": "Évaluation",
        "single_choice": "Choix unique"
      },
      "tabs": {
        "submissions": "Soumissions",
        "survey": "Sondage"
      }
    }
  }
}
